var isPoint = function (point) {
    return point.hasOwnProperty('x') && point.hasOwnProperty('y');
};

export { isPoint };



//////////////////
// WEBPACK FOOTER
// ./node_modules/popmotion/dist/es/utils/is-point.js
// module id = null
// module chunks = 